import { calculateFileSize } from '@pba/utils';
import type { ProgramEvent } from 'models';
import { Attachments, Card, Icon } from 'ui';
import { SaveSingleAttachmentButton } from 'features/attachments';
import { SaveZipButton } from './save-zip-button';

type P = {
  event: ProgramEvent;
};

const ProgramEventDetailAttachments = ({ event }: P) => {
  if (event.eventsFiles.length === 0) {
    return null;
  }

  return (
    <Card
      extra={<SaveZipButton eventId={event.id} />}
      title={<Card.Title icon={<Icon icon="attachment-line" />}>Attachments</Card.Title>}
    >
      <Attachments
        attachments={event.eventsFiles.map((file) => ({
          ...file,
          byteSize: calculateFileSize(file.byteSize),
          extra: <SaveSingleAttachmentButton attachment={file} />,
        }))}
      />
    </Card>
  );
};

export default ProgramEventDetailAttachments;
